import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../../services/shared/utils/utils.service';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ApiCDCService } from '../../../services/apiCDC/api-cdc.service';
import { OfferCustomerPayload, OfferCustomerResponse } from '../../../models/offerCustomerGenerated.model';
import { LinksModalComponent } from '../links-modal/links-modal.component';
import { LoadingService } from '../../../services/loading/loading.service';

@Component({
  selector: 'app-generate-customer-offer-modal',
  templateUrl: './generate-customer-offer-modal.component.html',
  styleUrl: './generate-customer-offer-modal.component.css'
})
export class GenerateCustomerOfferModal {

  private destroy$ = new Subject<void>();

  form: FormGroup;
  offerCodes: string[] = []
  constructor(
    private apiService: ApiCDCService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<GenerateCustomerOfferModal>,
    private snackBar: SnackbarService,
    private translationService: TranslationService,
    private fb: FormBuilder,
    private loadingService: LoadingService,
    @Inject(MAT_DIALOG_DATA) public data: { offerCodes: string[] }
    )
  {
    this.offerCodes = data.offerCodes;
    this.form = this.fb.group({
      customerCode: ['', [this.customerCodeValidator]],
      offerCode: ['', [Validators.required]]
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.form.valid) {
      const customerCode: string = this.form.get('customerCode')?.value;
      const offerCode: string = this.form.get('offerCode')?.value;

      var payload: OfferCustomerPayload = {
        manager:"testManager",
        code: offerCode,
        subCodes:[],
        expirationDate: null
      };

      this.loadingService.show();
      this.apiService.createOfferForCustomer(customerCode, payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: OfferCustomerResponse) => {
          this.dialogRef.close();
          this.loadingService.hide();
          this.dialog.open(LinksModalComponent, {
            width: '30%',
            data: {
              links: [
                {
                  label: this.translationService.translate("Customer Link"),
                  url: response.customerUrl
                },
                {
                  label: this.translationService.translate("Solocal Link"),
                  url: response.solocalUrl
                }
              ]
            }
          });
        },
        error: (error) => {
          this.snackBar.showError(this.translationService.translate('Error on create this offer for customer') + ' ' + customerCode);
          this.dialogRef.close();
          this.loadingService.hide();
        }
      });
    }
  }

  customerCodeValidator(control: any) {
    let value = control.value || '';
    const cleanedValue = value.replace(/[^0-9]/g, '');

    if (cleanedValue !== value) {
      control.setValue(cleanedValue, { emitEvent: false });
    }

    if (cleanedValue != '' && /^[0-9]{8}$/.test(cleanedValue)) {
      return null;
    }

    return { invalidCustomerCode: true };
  }
}
